import Vue from 'vue'
import Vant from 'vant'
import App from './App.vue'
import router from './router/router'
import store from './store/store'

import "vant/lib/index.less"
import "@/assets/css/custom-theme.less"
// import '../public/vconsole'
// import '@/utils/plugins'

Vue.use(Vant)
Vue.config.productionTip = false
// api 请求挂载到vue原型上
import Api from './api/api'
Vue.prototype.http = Api

// utils 挂载到vue原型上
import Utils from './assets/js/utils'
Vue.prototype.utils = Utils

//引入day.js
import dayjs from 'dayjs';
Vue.prototype.dayjs = dayjs;

// 移动端点击延时问题
import FastClick from 'fastclick'
// 解决iOS机型点击输入框不能聚焦的问题
FastClick.prototype.focus = function (targetElement) {
  targetElement.focus()
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
